import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { abbreviateLongName } from '../../../utils/nameAbbreviator';

const PatientTableRow = ({ patient, index, onEdit, onDelete, onSchedule, onViewDetails }) => {
  const formatWhatsApp = (phone) => {
    if (!phone) return '-';
    const numbers = phone?.replace(/\D/g, '');
    if (numbers?.length === 11) {
      return `(${numbers?.slice(0, 2)}) ${numbers?.slice(2, 7)}-${numbers?.slice(7)}`;
    }
    if (numbers?.length === 10) {
      return `(${numbers?.slice(0, 2)}) ${numbers?.slice(2, 6)}-${numbers?.slice(6)}`;
    }
    return phone;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'sem registro';
    
    try {
      const date = new Date(dateString);
      const day = String(date?.getDate())?.padStart(2, '0');
      const month = String(date?.getMonth() + 1)?.padStart(2, '0');
      const year = date?.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return 'sem registro';
    }
  };

  return (
    <tr className={`border-b border-gray-200 transition-colors ${
      index % 2 === 0 ? 'bg-gray-50 hover:bg-gray-100' : 'bg-gray-100 hover:bg-gray-200'
    }`}>
      <td className="px-3 sm:px-4 lg:px-6 py-3 sm:py-4">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-indigo-100 flex items-center justify-center flex-shrink-0">
            <span className="text-xs sm:text-sm font-semibold text-indigo-600">
              {patient?.full_name?.split(' ')?.map(n => n?.[0])?.join('')?.slice(0, 2)?.toUpperCase() || 
               patient?.name?.split(' ')?.map(n => n?.[0])?.join('')?.slice(0, 2)?.toUpperCase()}
            </span>
          </div>
          <div className="min-w-0 flex-1">
            <p className="font-medium text-gray-900 truncate text-sm sm:text-base">
              {abbreviateLongName(patient?.full_name || patient?.name)}
            </p>
            <div className="flex items-center gap-1 sm:hidden mt-1">
              <Icon name="MessageCircle" size={14} className="text-gray-400 flex-shrink-0" />
              <span className="text-xs text-gray-600 truncate">
                {formatWhatsApp(patient?.whatsapp_number || patient?.phone)}
              </span>
            </div>
          </div>
        </div>
      </td>
      <td className="px-3 sm:px-4 lg:px-6 py-3 sm:py-4 hidden sm:table-cell">
        <div className="flex items-center gap-2">
          <Icon name="MessageCircle" size={16} className="text-gray-400 flex-shrink-0" />
          <span className="text-sm text-gray-700">
            {formatWhatsApp(patient?.whatsapp_number || patient?.phone)}
          </span>
        </div>
      </td>
      <td className="px-3 sm:px-4 lg:px-6 py-3 sm:py-4 hidden md:table-cell">
        <div className="flex items-center justify-center gap-2">
          <Icon name="Calendar" size={16} className="text-gray-400 flex-shrink-0" />
          <span className="text-sm text-gray-700 font-medium">
            {patient?.totalSessions || 0}
          </span>
        </div>
      </td>
      <td className="px-3 sm:px-4 lg:px-6 py-3 sm:py-4 hidden md:table-cell">
        <div className="flex items-center justify-center gap-2">
          <Icon name="Clock" size={16} className="text-gray-400 flex-shrink-0" />
          <span className="text-sm text-gray-700">
            {formatDate(patient?.lastVisit)}
          </span>
        </div>
      </td>
      <td className="px-3 sm:px-4 lg:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-center gap-1 sm:gap-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onViewDetails(patient)}
            title="Ver detalhes"
            className="h-8 w-8 sm:h-9 sm:w-9"
          >
            <Icon name="Eye" size={16} className="sm:w-[18px] sm:h-[18px]" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onEdit(patient)}
            title="Editar paciente"
            className="h-8 w-8 sm:h-9 sm:w-9"
          >
            <Icon name="Edit" size={16} className="sm:w-[18px] sm:h-[18px]" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onDelete(patient)}
            title="Excluir paciente"
            className="h-8 w-8 sm:h-9 sm:w-9"
          >
            <Icon name="Trash2" size={16} className="text-red-600 sm:w-[18px] sm:h-[18px]" />
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default PatientTableRow;